module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-01-c970386a5ace5cded963293dbeae4a85.svg";